import { useState } from "react";
import { useTheme } from "../../../hooks/useTheme";
import styled from "../../../styles";
import { ButtonWrap, CTA } from "../../CTA";
import { Flex } from "../../Flex";
import Loader from "../../Loader";
import { Underline } from "../../Tabs";
import { Text } from "../../Text";
import { TextArea } from "../../TextArea";
import { View } from "../../View";

const StyledFlex = styled(Flex)`
  display: flex;
  align-items: stretch;
  flex-direction: column;
`;

interface Props {
  onConfirm: (issue: string) => void;
  onCancel: () => void;
  isLoading: boolean;
  creatorName: string;
  brandName: string;
}

export const ReportIssueOverlay = (props: Props) => {
  const [error, setError] = useState("");
  const [issue, setIssue] = useState("");
  const theme = useTheme();

  return (
    <>
      {props.isLoading ? (
        <Flex align="center" justify="center">
          <Loader />
        </Flex>
      ) : (
        <StyledFlex>
          <Text
            weight="bold"
            size="xl"
            margin={"0 0 0 0"}
            colorPreset="heading"
          >
            Report Issue
          </Text>
          <Underline selected />
          <Text margin={"m 0 0 0"} colorPreset="secondary" isInline>
            Let Joli know about any issues {" — "}
            <span
              style={{
                fontWeight: theme.typography.weight.semi,
                color: theme.color.typography.text,
              }}
            >
              This information will not be shared with the influencer.
            </span>
          </Text>

          <Text weight="bold" margin="l 0 xs" size="s">
            Details
          </Text>
          <TextArea
            rows={4}
            placeholder={"Describe your issue..."}
            onChange={(e) => {
              setIssue(e.currentTarget.value);
            }}
          />
          {error ? (
            <Text margin="0 0 0" colorPreset="error">
              {error}
            </Text>
          ) : null}

          <ButtonWrap margin="xl 0 0">
            <CTA type="secondary" to="#" onClick={props.onCancel}>
              Cancel
            </CTA>
            <CTA
              to="#"
              onClick={() => {
                if (!issue) {
                  setError("Please provide some more details about the issue");
                }
                props.onConfirm(issue);
              }}
            >
              {props.isLoading ? "Loading..." : "Submit"}
            </CTA>
          </ButtonWrap>
        </StyledFlex>
      )}
    </>
  );
};

export const Alert = styled(View)`
  background-color: ${(p) => p.theme.color.secondary}30;
  border-left: 3px solid ${(p) => p.theme.color.secondary};
  border-radius: 2px;
  width: 100%;
  box-sizing: border-box;

  color: ${(p) => p.theme.color.secondary};
`;
